import axios from "axios";

export const getMacrocategoriaByIdApi = (id) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/sost/macrocategorie/${id}`);
};

export const getStrutturaClassiMacrocategorieApi = () => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + "/api/sost/macrocategorie/classi/strutture/")
}

export const deleteStrutturaClasseMacrocategoriaApi = (id) => {
    return axios.delete(process.env.REACT_APP_API_ENDPOINT + `/api/sost/macrocategorie/classi/strutture/${id}`)
}

export const getClasseMacrocategoriaByIdApi = (id) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/sost/macrocategorie/classi/${id}`);
};

export const aggiornaClasseMacrocategoriaApi = (id, classe) => {
    return axios.put(process.env.REACT_APP_API_ENDPOINT + `/api/sost/macrocategorie/classi/${id}`, classe);
};

export const aggiungiClasseMacrocategoriaApi = (classe) => {
    return axios.post(process.env.REACT_APP_API_ENDPOINT + "/api/sost/macrocategorie/classi/", classe);
};

export const getMacrocategorieApi = (filtri = '') => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/sost/macrocategorie/${filtri}`);
};

export const getStrutturaMacrocategorieApi = (idSel) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/sost/macrocategorie/struttura/${idSel}`);
};

export const deleteMacrocategoriaByIdApi = (id) => {
    return axios.delete(process.env.REACT_APP_API_ENDPOINT + `/api/sost/macrocategorie/${id}`);
};

export const getMacrocategoriePadriApi = (idClasse) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/sost/macrocategorie/padri/${idClasse}`);
};

export const getClassiMacrocategorieApi = (filtri = '') => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/sost/macrocategorie/classi/${filtri}`);
};

export const aggiornaMacrocategoriaApi = (id, macrocategoria) => {
    return axios.put(process.env.REACT_APP_API_ENDPOINT + `/api/sost/macrocategorie/${id}`, macrocategoria);
};

export const aggiungiMacrocategoriaApi = (macrocategoria) => {
    return axios.post(process.env.REACT_APP_API_ENDPOINT + "/api/sost/macrocategorie/", macrocategoria);
};

export const aggiungiStrutturaClasseMacrocategoriaApi = (classe) => {
    return axios.post(process.env.REACT_APP_API_ENDPOINT + "/api/sost/macrocategorie/classi/strutture/", classe)
}

export const deleteClasseMacrocategoriaApi = (id) => {
    return axios.delete(process.env.REACT_APP_API_ENDPOINT + `/api/sost/macrocategorie/classi/${id}`)
}

export const downloadTemplateMacrocategorie = () => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/sost/macrocategorie/template-import/`)
}